import axios from "axios";
import { ApiUrlUtil } from "../../utils/apiUrlUtil";
import { ParamUtil, RequestParam } from "../../utils/paramUtil";
import { HeadersUtil } from "../../utils/headersUtil";

export class Dcs0101Service {
  private static _dcs0101Service: Dcs0101Service;

  public static getInstance(): Dcs0101Service {
    if (!Dcs0101Service._dcs0101Service) {
      Dcs0101Service._dcs0101Service = new Dcs0101Service();
    }
    return Dcs0101Service._dcs0101Service;
  }

  public getList(modelSearch: any) {
    const params: RequestParam[] = ParamUtil.toRequestParams(modelSearch);
    const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_MAIN_URL + "/dcs/dcs0101/getLstConnection.do", params);
    return axios.get(url, {
      headers: HeadersUtil.getHeadersAuth(),
    });
  }

  public getConnectionDetail(connectionId: any) {
    const params: RequestParam[] = ParamUtil.toRequestParams(connectionId);
    const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_MAIN_URL + "/dcs/dcs0101/getConnectionDetail.do", params);
    return axios.get(url, {
      headers: HeadersUtil.getHeadersAuth(),
    });
  }

  public updateConnection(req: any) {
    const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_MAIN_URL + "/dcs/dcs0101/update.do");
    return axios.post(url, req, {
      headers: HeadersUtil.getHeadersAuth(),
    });
  }

  public insertConnection(req: any) {
    const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_MAIN_URL + "/dcs/dcs0101/insert.do");
    return axios.post(url, req, {
      headers: HeadersUtil.getHeadersAuth(),
    });
  }

  public delete(connectionId: any) {
    const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_MAIN_URL + "/dcs/dcs0101/" + connectionId + "/deleteConnection.do");
    return axios.delete(url, {
      headers: HeadersUtil.getHeadersAuth(),
    });
  }

  public getDataByConnectionNm(req: any) {
    const params: RequestParam[] = ParamUtil.toRequestParams(req);
    const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_MAIN_URL + "/dcs/dcs0101/getData.do", params);
    return axios.get(url, {
      headers: HeadersUtil.getHeadersAuth(),
    });
  }

  public getDataMapDetail(req: any) {
    const params: RequestParam[] = ParamUtil.toRequestParams(req);
    const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_MAIN_URL + "/dcs/dcs0101/getDataMapDetail.do", params);
    return axios.get(url, {
      headers: HeadersUtil.getHeadersAuth(),
    });
  }

  public startColl(req: any) {
    const params: RequestParam[] = ParamUtil.toRequestParams(req);
    const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_COLLECTION_API + "/dcm/start", params);
    return axios.get(url, {
      headers: HeadersUtil.getHeadersAuth(),
    });
  }

  public stopColl(req: any) {
    const params: RequestParam[] = ParamUtil.toRequestParams(req);
    const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_COLLECTION_API + "/dcm/stop", params);
    return axios.get(url, {
      headers: HeadersUtil.getHeadersAuth(),
    });
  }

  public restartColl(req: any) {
    const params: RequestParam[] = ParamUtil.toRequestParams(req);
    const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_COLLECTION_API + "/dcm/restart", params);
    return axios.get(url, {
      headers: HeadersUtil.getHeadersAuth(),
    });
  }

  public startDel(req: any) {
    const params: RequestParam[] = ParamUtil.toRequestParams(req);
    const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_DELIVERY_API + "/ddm/start", params);
    return axios.get(url, {
      headers: HeadersUtil.getHeadersAuth(),
    });
  }

  public stopDel(req: any) {
    const params: RequestParam[] = ParamUtil.toRequestParams(req);
    const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_DELIVERY_API + "/ddm/stop", params);
    return axios.get(url, {
      headers: HeadersUtil.getHeadersAuth(),
    });
  }

  public restartDel(req: any) {
    const params: RequestParam[] = ParamUtil.toRequestParams(req);
    const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_DELIVERY_API + "/ddm/restart", params);
    return axios.get(url, {
      headers: HeadersUtil.getHeadersAuth(),
    });
  }

  public updateConnectionStatus(req: any) {
    const params: RequestParam[] = ParamUtil.toRequestParams(req);
    const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_MAIN_URL + "/dcs/dcs0101/updateConnectionStatus.do", params);
    return axios.put(url, {
      headers: HeadersUtil.getHeadersAuth(),
    });
  }

  public checkConnectionStatus(req: any) {
    const params: RequestParam[] = ParamUtil.toRequestParams(req);
    const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_MAIN_URL + "/dcs/dcs0101/checkDeviceStatus.do", params);
    return axios.get(url, {
      headers: HeadersUtil.getHeadersAuth(),
    });
  }

  public updateDeviceStatus(req: any) {
    const params: RequestParam[] = ParamUtil.toRequestParams(req);
    const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_MAIN_URL + "/dcs/dcs0101/updateDeviceStatus.do", params);
    return axios.put(url, {
      headers: HeadersUtil.getHeadersAuth(),
    });
  }

  public deleteCollContainer(connId: any) {
    const params: RequestParam[] = ParamUtil.toRequestParams(connId);
    const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_COLLECTION_API + "/dcm/delete", params);
    return axios.get(url, {
      headers: HeadersUtil.getHeadersAuth(),
    });
  }

  public deleteDelContainer(connId: any) {
    const params: RequestParam[] = ParamUtil.toRequestParams(connId);
    const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_DELIVERY_API + "/ddm/delete", params);
    return axios.get(url, {
      headers: HeadersUtil.getHeadersAuth(),
    });
  }

  public async exportData(req: any) {
    try {
      const params: RequestParam[] = ParamUtil.toRequestParams(req);
      const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_MAIN_URL + "/dcs/dcs0101/exportData.do", params);

      const response = await axios.get(url, {
        responseType: "blob", // 🔹 Quan trọng: Cần để Axios hiểu là file nhị phân
      });

      let curDate = new Date();
      let date = curDate.getDate();
      let month = curDate.getMonth() + 1;
      let year = curDate.getFullYear();

      let fileName = req.tableNm + "-" + date + "/" + month + "/" + year + ".xlsx";

      // 🔹 Tạo URL và tải file về
      const urlFile = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = urlFile;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error("❌ Lỗi tải file Excel: ", error);
    }
  }
}
